module.exports = __webpack_public_path__ + "static/media/refund-successful-green.e0d55f54.svg";